import { render, staticRenderFns } from "./PatientChangeRegimen.vue?vue&type=template&id=7135ba26"
import script from "./PatientChangeRegimen.vue?vue&type=script&lang=js"
export * from "./PatientChangeRegimen.vue?vue&type=script&lang=js"
import style0 from "./PatientChangeRegimen.vue?vue&type=style&index=0&id=7135ba26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports